import { render, staticRenderFns } from "./RemediationModal.vue?vue&type=template&id=aedcddc4"
import script from "./RemediationModal.vue?vue&type=script&lang=ts"
export * from "./RemediationModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RemediationSkeleton: require('/build/apps/legacy/components/Dependencies/RemediationModal/RemediationSkeleton.vue').default,RemediationSelector: require('/build/apps/legacy/components/Dependencies/RemediationModal/RemediationSelector.vue').default,RemediationModalError: require('/build/apps/legacy/components/Dependencies/RemediationModal/RemediationModalError.vue').default,RemediationModalManual: require('/build/apps/legacy/components/Dependencies/RemediationModal/RemediationModalManual.vue').default,RemediationModalGenerating: require('/build/apps/legacy/components/Dependencies/RemediationModal/RemediationModalGenerating.vue').default,ZModal: require('/build/apps/legacy/components/zeal/ZModal/ZModal.vue').default})
